import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import EventImage from "../assets/event-image1.jpeg";
import hiring from "../assets/About/2.jpeg";
import {
  Instagram,
  Facebook,
  Youtube,
  X,
  Calendar,
  MapPin,
  Clock,
} from "lucide-react";
import Updates from "../components/Home/Updates";
import { EventData } from "./Event/EventData";
import { useNavigate } from "react-router-dom";

// Sample event data as provided
// export const EventData = [
//   {
//     event: {
//       name: "Educational Expo 2K25",
//       presented_by:
//         "M.S Education Consultants (A division of MaheshSuchit Immigration Pvt. Ltd.)",
//       locations: [
//         { city: "Surat", date: "2025-04-10", venue: "Prarthna Hall, VNSGU" },
//         {
//           city: "Anand",
//           date: "2025-04-12",
//           venue: "Dolphin Restaurant, Nr. M.S. House, Nr. Panchal Hall",
//         },
//         {
//           city: "Ahmedabad",
//           date: "2025-04-13",
//           venue: "AMA, Dr Vikram Sarabhai Marg, University Area, Ahmedabad",
//         },
//       ],
//       timings: "10:00 AM – 6:00 PM",
//       entry_fee: "FREE",
//       about:
//         "M.S Education Consultants proudly presents its 10th Educational Expo, where students can explore global education opportunities. With a strong record of 50k+ students sent abroad, this event connects aspiring students with top universities, scholarship opportunities, and expert guidance.",
//       highlights: {
//         counseling:
//           "1:1 Counselling – Interact directly with university representatives",
//         scholarships:
//           "High Scholarships – Explore financial aid & merit-based scholarships",
//         lucky_draw_benefits: [
//           "Free IELTS, PTE, & Language CERT Vouchers",
//           "Free TOEFL Study Material",
//           "Assured Goodies for All Attendees",
//           "50% Off on all services by M.S Education",
//         ],
//         vip_services:
//           "Fast VVIP Services – Priority application processing for online registrants who submit required documents",
//       },
//       images: [
//         "/gallery/event1-image1.jpg",
//         "/gallery/event1-image2.jpg",
//         "/gallery/event1-image3.jpg",
//       ],
//     },
//   },
//   {
//     event: {
//       name: "Career Counseling Summit",
//       presented_by: "M.S Education Consultants",
//       locations: [
//         {
//           city: "Vadodara",
//           date: "2025-05-15",
//           venue: "MS Education Office, Alkapuri",
//         },
//         { city: "Rajkot", date: "2025-05-17", venue: "The Grand Bhagwati" },
//       ],
//       timings: "11:00 AM – 5:00 PM",
//       entry_fee: "FREE",
//       about:
//         "Join us for an exclusive career counseling summit where industry experts will guide students on choosing the right career path and educational opportunities abroad.",
//       highlights: {
//         counseling: "Expert Career Guidance Sessions",
//         scholarships: "Information on Merit Scholarships",
//         lucky_draw_benefits: [
//           "Free Career Assessment Tests",
//           "Discount Vouchers for Consultation",
//           "Study Materials",
//         ],
//         vip_services: "Priority Registration for International Programs",
//       },
//       images: ["/gallery/event2-image1.jpg", "/gallery/event2-image2.jpg"],
//     },
//   },
//   {
//     event: {
//       name: "International Education Fair",
//       presented_by: "M.S Education Consultants",
//       locations: [
//         { city: "Surat", date: "2025-06-20", venue: "JB Diamond Institute" },
//         {
//           city: "Ahmedabad",
//           date: "2025-06-22",
//           venue: "Courtyard by Marriott",
//         },
//       ],
//       timings: "10:00 AM – 7:00 PM",
//       entry_fee: "FREE",
//       about:
//         "Explore educational opportunities in top international destinations. Meet university representatives and get on-spot admissions with scholarship offers.",
//       highlights: {
//         counseling: "Direct University Interactions",
//         scholarships: "On-spot Scholarship Assessments",
//         lucky_draw_benefits: [
//           "Application Fee Waivers",
//           "Free Visa Counseling",
//           "Exclusive Study Guides",
//         ],
//         vip_services: "Express Processing for Early Registrants",
//       },
//       images: [
//         "/gallery/event3-image1.jpg",
//         "/gallery/event3-image2.jpg",
//         "/gallery/event3-image3.jpg",
//       ],
//     },
//   },
// ];

// Sample gallery images (for demonstration)
const sampleGalleryImages = [
  "/gallery/sample1.jpg",
  "/gallery/sample2.jpg",
  "/gallery/sample3.jpg",
  "/gallery/sample4.jpg",
  "/gallery/sample5.jpg",
  "/gallery/sample6.jpg",
  "/gallery/sample7.jpg",
  "/gallery/sample8.jpg",
  "/gallery/sample9.jpg",
];

export default function ModernGalleryPage() {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [activeTab, setActiveTab] = useState("all"); // 'all' or event index
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  
  const openImagePreview = (img) => {
    setPreviewImage(img);
    setShowPreview(true);
  };
  
  const closeImagePreview = () => {
    setShowPreview(false);
    setPreviewImage(null);
  };
  
  const openPopup = (event) => {
    setSelectedEvent(event);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedEvent(null);
  };

  // Filter images based on selected event or show all
  const getDisplayImages = () => {
    if (activeTab === "all") {
      return sampleGalleryImages;
    } else {
      const eventIndex = parseInt(activeTab);

      return EventData[eventIndex]?.event?.images || [];
    }
  };

  const importAll = (r) => r.keys().map(r);

  const images = importAll(
    require.context("../../public/gallery", false, /\.(png|jpe?g|svg)$/)
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-100"
    >
       <section className="relative overflow-hidden bg-primary-cream py-20 sm:py-32">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
                  <div className="max-w-2xl">
                    <h1 className="text-4xl font-extrabold tracking-tight text-primary sm:text-5xl md:text-6xl">
                     
                    
                      <span className="block">Showcasing </span>
                      <span className="block text-black">our story through every frame.</span>
                      <span className="block mt-3 tracking-normal text-2xl">From global seminars to local milestones.</span>
                    </h1>
                    <p className="mt-6 text-xl text-primary-dark">
                    Discover the highlights of our educational journey captured in vibrant visuals.
                    </p>
                  </div>
                  <div className="relative w-full max-w-lg lg:max-w-2xl xl:max-w-3xl">
                  <div className="relative">
                <img
                  src={hiring}
                  alt="Girl with laptop"
                  width={600}
                  height={600}
                  className="rounded-lg lg:ml-12"
                />
              </div>
                        </div>
                </div>
              </div>
            </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-white rounded-3xl shadow-xl overflow-hidden backdrop-blur-sm border border-gray-100"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-100/50 to-purple-100/50 backdrop-blur-sm"></div>
              <div className="relative p-8 md:p-10">
                <div className="flex items-center mb-6">
                  <div className="h-12 w-1 bg-gradient-to-b from-indigo-600 to-purple-600 rounded-full mr-4"></div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight">
                    About Our Gallery
                  </h2>
                </div>

                <div className="space-y-4 text-gray-700">
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                    viewport={{ once: true }}
                    className="text-lg leading-relaxed"
                  >
                    Welcome to the{" "}
                    <span className="text-indigo-700 font-medium">
                      M.S Education Consultants
                    </span>{" "}
                    events gallery. Explore our past and upcoming educational
                    events, conferences, and consultations. Each event is
                    thoughtfully curated to help students discover global
                    education opportunities and expand their horizons.
                  </motion.p>

                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                    viewport={{ once: true }}
                    className="text-lg leading-relaxed"
                  >
                    Click on any event below to view details and browse our
                    comprehensive photo collection that showcases our journey in
                    helping{" "}
                    <span className="font-semibold text-indigo-700">
                      over 50,000 students
                    </span>{" "}
                    achieve their academic dreams abroad.
                  </motion.p>

                  <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    viewport={{ once: true }}
                    className="pt-4 flex flex-wrap gap-4"
                  >
                    <span className="px-4 py-2 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium">
                      Educational Events
                    </span>
                    <span className="px-4 py-2 bg-purple-50 text-purple-700 rounded-full text-sm font-medium">
                      Student Consultations
                    </span>
                    <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-medium">
                      Global Conferences
                    </span>
                  </motion.div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Events List Section */}
      <motion.section
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-50"
      >
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold mb-8 text-gray-800">
            Featured Events
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {EventData.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer"
                onClick={() => {
                  openPopup(item.event);
                  setActiveTab(index.toString());
                }}
              >
                <div className="relative h-48 bg-gray-200">
                  <img
                    src={EventImage}
                    alt={item.event.name}
                    className="w-full h-full object-cover"
                  />

                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                    <h3 className="text-xl font-bold text-white">
                      {item.event.name}
                    </h3>
                  </div>
                </div>
                <div className="p-4">
                  <div className="flex items-center text-gray-600 mb-2">
                    <Calendar className="w-4 h-4 mr-2" />
                    <span className="text-sm">
                      {item.event.locations[0].date}
                      {item.event.locations.length > 1 &&
                        ` + ${item.event.locations.length - 1} more`}
                    </span>
                  </div>
                  <div className="flex items-center text-gray-600 mb-3">
                    <MapPin className="w-4 h-4 mr-2" />
                    <span className="text-sm">
                      {item.event.locations.map((loc) => loc.city).join(", ")}
                    </span>
                  </div>
                  <p className="text-gray-700 text-sm line-clamp-2 h-10">
                    {item.event.about}
                  </p>
                  <div className="mt-4">
                    <button className="w-full py-2 px-4 bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg hover:opacity-90 transition duration-300">
                      View Details
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>


      {/* Gallery Images Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="bg-gradient-to-r from-gray-100 to-blue-50 py-8 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {images.map((image, index) => (
              <motion.div
                onClick={() => openImagePreview(image)}
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                viewport={{ once: true }}
                className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer aspect-square"
              >
                <div className="w-full h-full relative">
                  <img
                    src={image}
                    alt={`Gallery photo ${index + 1}`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = "/api/placeholder/400/400";
                      e.target.alt = "Image placeholder";
                    }}
                  />
                  <div className="absolute inset-0 bg-black/0 hover:bg-black/30 transition-all duration-300 flex items-center justify-center opacity-0 hover:opacity-100">
                    <span className="text-white font-medium text-lg">View</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
      
      {showPreview && previewImage && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex items-center justify-center px-4">
    <div className="relative max-w-4xl w-full">
      <button
        onClick={closeImagePreview}
        className="absolute -top-8 -right-8 text-white text-3xl font-bold z-50"
      >
        &times;
      </button>
      <img
        src={previewImage}
        alt="Preview"
        className="rounded-lg max-h-[90vh] w-full object-contain"
      />
    </div>
  </div>
)}


      {/* Social Media Section (Kept from original) */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="py-16 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: "Instagram",
                icon: Instagram,
                color: "bg-gradient-to-r from-pink-500 to-orange-500",
                url: "https://www.instagram.com/m.s.education",
              },
              {
                name: "Facebook",
                icon: Facebook,
                color: "bg-gradient-to-r from-blue-600 to-blue-800",
                url: "https://www.facebook.com/mseducationconsultancy/",
              },
              {
                name: "YouTube",
                icon: Youtube,
                color: "bg-gradient-to-r from-red-600 to-red-800",
                url: "https://youtube.com/@m.s.educationconsultant?si=YtBaRy_CyLHe2VJG",
              },
            ].map((platform) => (
              <motion.div
                key={platform.name}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                viewport={{ once: true }}
                className="bg-white rounded-2xl shadow-lg overflow-hidden"
              >
                <div
                  className={`${platform.color} h-32 flex items-center justify-center`}
                >
                  <platform.icon className="w-16 h-16 text-white" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">
                    {platform.name}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Follow us on {platform.name} for the latest updates and
                    content.
                  </p>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className={`w-full py-3 px-4 rounded-full font-semibold text-white ${platform.color} hover:opacity-90 transition duration-300`}
                    onClick={() =>
                      window.open(`${platform.url.toLowerCase()}`, "_blank")
                    }
                  >
                    Visit {platform.name}
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Updates Component (Kept from original) */}
      <Updates />

      {/* Event Detail Popup */}
      <AnimatePresence>
        {showPopup && selectedEvent && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50 overflow-y-auto"
            onClick={closePopup}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="bg-white rounded-2xl p-6 max-w-2xl w-full shadow-2xl max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800">
                  {selectedEvent.name}
                </h3>
                <motion.button
                  whileHover={{ rotate: 90 }}
                  onClick={closePopup}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-6 h-6" />
                </motion.button>
              </div>

              <p className="text-gray-600 italic mb-4">
                {selectedEvent.presented_by}
              </p>

              <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
                Event Details
              </h4>

              <div className="flex items-center mb-3">
                <Clock className="w-5 h-5 mr-2 text-blue-600" />
                <span>{selectedEvent.timings}</span>
              </div>

              <div className="mb-4">
                <div className="flex items-start mb-1">
                  <MapPin className="w-5 h-5 mr-2 text-blue-600 mt-1" />
                  <div>
                    <h5 className="font-medium">Locations:</h5>
                    <ul className="list-disc pl-5 mt-1">
                      {selectedEvent.locations.map((loc, idx) => (
                        <li key={idx} className="mb-1">
                          <span className="font-medium">{loc.city}</span> -{" "}
                          {loc.date} at {loc.venue}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="my-4">
                <h5 className="font-medium mb-2">About:</h5>
                <p className="text-gray-700">{selectedEvent.about}</p>
              </div>

              <div className="my-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3">
                  Event Highlights
                </h4>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <p className="mb-2">
                    <span className="font-medium">Counseling:</span>{" "}
                    {selectedEvent.highlights.counseling}
                  </p>
                  <p className="mb-2">
                    <span className="font-medium">Scholarships:</span>{" "}
                    {selectedEvent.highlights.scholarships}
                  </p>

                  <h5 className="font-medium mt-3 mb-1">
                    Lucky Draw Benefits:
                  </h5>
                  <ul className="list-disc pl-5">
                    {selectedEvent.highlights.lucky_draw_benefits.map(
                      (benefit, idx) => (
                        <li key={idx} className="mb-1">
                          {benefit}
                        </li>
                      )
                    )}
                  </ul>

                  <p className="mt-3">
                    <span className="font-medium">VIP Services:</span>{" "}
                    {selectedEvent.highlights.vip_services}
                  </p>
                </div>
              </div>

              <div className="mt-6 flex justify-end gap-3">
                <button
                  className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-2 px-6 rounded-lg hover:opacity-90 transition duration-300"
                  onClick={() => navigate(`/event-details/${1}`)}
                >
                  Register
                </button>
                <button
                  className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-2 px-6 rounded-lg hover:opacity-90 transition duration-300"
                  onClick={closePopup}
                >
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
// Old gallery page
// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Instagram, Facebook, Youtube, X } from "lucide-react";
// import Updates from "../components/Home/Updates";

// export default function ModernGalleryPage() {
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupContent, setPopupContent] = useState("");

//   const openPopup = (content) => {
//     setPopupContent(content);
//     setShowPopup(true);
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//     setPopupContent("");
//   };
//   const importAll = (r) => r.keys().map(r);
//   const images = importAll(
//     require.context("../../public/gallery", false, /\.(png|jpe?g|svg)$/)
//   );
//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 0.5 }}
//       className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-100"
//     >
//       <motion.header
//         initial={{ y: -50, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ duration: 0.7 }}
//         className="relative  bg-primary-brown text-white py-20 px-4 sm:px-6 lg:px-8"
//       >
//         <div className="max-w-7xl mx-auto">
//           <motion.h1
//             initial={{ x: -50, opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             transition={{ delay: 0.2, duration: 0.5 }}
//             className="text-5xl font-bold mb-4 text-white tracking-tight"
//           >
//             Our Journey in Pictures
//           </motion.h1>
//           <motion.p
//             initial={{ x: -50, opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             transition={{ delay: 0.3, duration: 0.5 }}
//             className="text-xl mb-8 text-white/80"
//           >
//             A Pictorial Showcase of Our Story and Achievements.
//           </motion.p>
//         </div>
//         <motion.svg
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="absolute bottom-0 left-0 w-full h-20 text-gray-50"
//           viewBox="0 0 100 100"
//           preserveAspectRatio="none"
//         >
//           <path d="M0,100 C40,0 60,0 100,100 Z" fill="currentColor" />
//         </motion.svg>
//       </motion.header>

//       <motion.section
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         viewport={{ once: true }}
//         className="bg-gradient-to-r from-gray-100 to-blue-50 py-16 px-4 sm:px-6 lg:px-8"
//       >
//         <div className="max-w-7xl mx-auto">
//           {/* <h2 className="text-4xl font-bold mb-12 text-center text-gray-800">
//             Gallery
//           </h2> */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//             {images.map((image, num) => (
//               <motion.div
//                 key={num}
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 whileHover={{ scale: 1.05 }}
//                 transition={{ duration: 0.3 }}
//                 viewport={{ once: true }}
//                 className="bg-white rounded-2xl shadow-lg overflow-hidden cursor-pointer"
//               >
//                 <img
//                   key={num}
//                   src={image}
//                   alt={`Photo ${num}`}
//                   className="w-full h-48 object-cover"
//                 />
//                 {/* <div className="p-4">
//                   <p className="text-gray-600">Description of Photo {num}</p>
//                 </div> */}
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </motion.section>

//       <Updates />
//       {/* <motion.section
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         viewport={{ once: true }}
//         className="py-16 px-4 sm:px-6 lg:px-8"
//       >
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-bold mb-12 text-center text-gray-800">
//             Latest Updates
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {["Blog Title 1", "Blog Title 2", "Blog Title 3"].map(
//               (title, index) => (
//                 <motion.div
//                   key={index}
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   whileInView={{ opacity: 1, scale: 1 }}
//                   whileHover={{ scale: 1.05 }}
//                   transition={{ duration: 0.3 }}
//                   viewport={{ once: true }}
//                   className="bg-white rounded-2xl shadow-lg overflow-hidden cursor-pointer"
//                   onClick={() => openPopup(`More content on ${title}`)}
//                 >
//                   <div className="p-6">
//                     <h3 className="text-xl font-semibold mb-2 text-gray-800">
//                       {title}
//                     </h3>
//                     <p className="text-gray-600">
//                       Short description of the blog...
//                     </p>
//                   </div>
//                 </motion.div>
//               )
//             )}
//           </div>
//         </div>
//       </motion.section> */}
//       <motion.section
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         viewport={{ once: true }}
//         className="py-16 px-4 sm:px-6 lg:px-8"
//       >
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {[
//               {
//                 name: "Instagram",
//                 icon: Instagram,
//                 color: "bg-gradient-to-r from-pink-500 to-orange-500",
//                 url: "https://www.instagram.com/m.s.education",
//               },
//               {
//                 name: "Facebook",
//                 icon: Facebook,
//                 color: "bg-gradient-to-r from-blue-600 to-blue-800",
//                 url: "https://www.facebook.com/mseducationconsultancy/",
//               },
//               {
//                 name: "YouTube",
//                 icon: Youtube,
//                 color: "bg-gradient-to-r from-red-600 to-red-800",
//                 url: "https://youtube.com/@m.s.educationconsultant?si=YtBaRy_CyLHe2VJG",
//               },
//             ].map((platform) => (
//               <motion.div
//                 key={platform.name}
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 whileHover={{ scale: 1.05 }}
//                 transition={{ duration: 0.3 }}
//                 viewport={{ once: true }}
//                 className="bg-white rounded-2xl shadow-lg overflow-hidden"
//               >
//                 <div
//                   className={`${platform.color} h-32 flex items-center justify-center`}
//                 >
//                   <platform.icon className="w-16 h-16 text-white" />
//                 </div>
//                 <div className="p-6">
//                   <h3 className="text-xl font-semibold mb-2">
//                     {platform.name}
//                   </h3>
//                   <p className="text-gray-600 mb-4">
//                     Follow us on {platform.name} for the latest updates and
//                     content.
//                   </p>
//                   <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                     className={`w-full py-3 px-4 rounded-full font-semibold text-white ${platform.color} hover:opacity-90 transition duration-300`}
//                     onClick={() =>
//                       window.open(`${platform.url.toLowerCase()}`, "_blank")
//                     }
//                   >
//                     Visit {platform.name}
//                   </motion.button>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </motion.section>

//       <AnimatePresence>
//         {showPopup && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
//           >
//             <motion.div
//               initial={{ scale: 0.8, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               exit={{ scale: 0.8, opacity: 0 }}
//               className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl"
//             >
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-xl font-semibold">Details</h3>
//                 <motion.button
//                   whileHover={{ rotate: 90 }}
//                   onClick={closePopup}
//                   className="text-gray-500 hover:text-gray-700"
//                 >
//                   <X className="w-6 h-6" />
//                 </motion.button>
//               </div>
//               <p>{popupContent}</p>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.div>
//   );
// }
